import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

export interface Props {
  discardedPoolMinutes: number
}

const Discarded = ({ discardedPoolMinutes }: Props) => (
  <Box gap="s6" alignItems="center" flexDirection="row" width="full" justifyContent="spaceBetween">
    <Text size="200" color="grey1000">
      {i18n.t('clock_in.sidepanel.balance.discarded')}
    </Text>
    <MinutesToText color="grey1000" value={discardedPoolMinutes} size="200" />
  </Box>
)

export default Discarded
